import { Dispatch, SetStateAction, createContext } from 'react';
import { useLocalStorage } from '../hooks/storage/useLocalStorage';
type ChatRoomUiState = {
    isChatRoomEnabled: boolean;
    setChatRoomEnabled: Dispatch<SetStateAction<boolean>>;
};
export const ChatRoomUiContext = createContext({} as ChatRoomUiState);
const { Provider } = ChatRoomUiContext;
type ChatRoomUiProviderProps = {
    children: JSX.Element;
};
export const ChatRoomUiProvider = ({ children }: ChatRoomUiProviderProps) => {
    const [isChatRoomEnabled, setChatRoomEnabled] = useLocalStorage(
        'chat_room',
        true
    );

    return (
        <Provider value={{ isChatRoomEnabled, setChatRoomEnabled }}>
            {children}
        </Provider>
    );
};
